export const gridPaperStyle = (top, extra = {}) => ({
  overflowX: 'auto',
  backgroundColor: '#fff',
  padding: 10,
  margin: 'auto',
  position: 'fixed',
  top,
  bottom: 20,
  left: 20,
  right: 20,
  border: '1px solid #cfcfcf',
  boxSizing: 'border-box',
  boxShadow: 'none',
  ...extra,
})
